import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MarkdownPipe } from '../../common/pipes/markdown.pipe';
import { presentWebsiteReport } from '../website-review';
import { novaResponseState, novaResponseNotice } from '../nova-response-contract';

@Component({
  selector: 'app-website-review',
  imports: [MarkdownPipe, DatePipe],
  templateUrl: './website-review.component.html',
  styleUrl: './website-review.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebsiteReviewComponent {
  content = input.required<string>();
  reportRequest = input(false);
  reportName = input('');
  reportDate = input('');
  reportPath = input('');
  summaryOnly = input(false);
  streaming = input(false);
  responseFailed = input(false);
  request = input('');
  state = computed(() => novaResponseState(this.content(), this.streaming(), this.responseFailed(), this.request()));
  notice = computed(() => novaResponseNotice(this.state()));
  review = computed(() => this.state() === 'answer' ? presentWebsiteReport(this.content(), this.reportRequest(), {
    name: this.reportName(), scanDate: this.reportDate(), path: this.reportPath(),
  }) : null);
}
